import  "./fixeddepature.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import Enquiryform from "./enquiryform";
export default function FixedDeparture() {
  const [opente, seTe] = useState(false);
  const [opentr, seTr] = useState(false);
  const [opentb, seTb] = useState(false);
  return (
    <section className="section-fixed">
      <div className="header">
        <h2>Fixed Departures</h2>
        <p>Guaranteed trips with confirmed departure dates</p>
      </div>

      <div className="grid-fixed">
      <div className="tc-card">
        {/* ── Image ── */}
        <div className="tc-image-wrap">
          <img
            src="/img/chitwan/chitwan3dslr.webp"
            alt="Pokhara, Nepal"
            className="tc-image"
          />
          <div className="tc-badge">7N/8D</div>
        </div>

        {/* ── Body ── */}
        <div className="tc-body">
          {/* Title */}
          <h2 className="tc-title">Nepal's Golden Triangle</h2>

          {/* Night pills */}
          <div className="tc-pills">
            <span className="tc-pill">
              <span className="tc-dot" />3N Kathmandu
            </span>
            <span className="tc-sep">•</span>
            <span className="tc-pill">
              <span className="tc-dot" />2N Chitwan
            </span>
            <span className="tc-sep">•</span>
            <span className="tc-pill">
              <span className="tc-dot" />2N Pokhara
            </span>
          </div>

          {/* Features grid */}
          <div className="tc-features">
            <ul className="tc-list">
              <li>All Entry Fee</li>
              <li>4 Star Hotels</li>
              <li>3 Activities</li>
            </ul>
            <ul className="tc-list">
              <li>Intercity Car Transfers</li>
              <li>Airport Transfers</li>
              <li>Selected Meals</li>
            </ul>
          </div>

          {/* Highlights */}
          <div className="tc-highlights">
            <div className="tc-highlight-row">
           <FontAwesomeIcon icon={faArrowRight} style={{color:"green"}}></FontAwesomeIcon>
              <span>
                Visit to <span className="tc-link">Boudhanath Stupa, Swayambhunath Temple, Pashupatinath Temple + more</span>
              </span>
            </div>
            <div className="tc-highlight-row">
            <FontAwesomeIcon icon={faArrowRight} style={{color:"green"}}></FontAwesomeIcon>
              <span>
                Visit to <span className="tc-link">Chitwan And Pokhara</span>
              </span>
            </div>
          </div>

          {/* Divider */}
          <div className="tc-divider" />

          {/* Price row */}
          <div className="tc-price-row">
            <div className="tc-emi">
              <p className="tc-emi-label">Trip Starts From</p>
              <p className="tc-emi-amount">Sept 21 2026</p>
            </div>
            <div className="tc-price"onClick={()=>seTe(true)}>
              <p className="tc-price-main">
               Get a Quote
              </p>
            </div>
          </div>


        </div>
      </div>

      <div className="tc-card">
        {/* ── Image ── */}
        <div className="tc-image-wrap">
          <img
            src="/img/capital/nagarkot.webp"
            alt="Pokhara, Nepal"
            className="tc-image"
          />
          <div className="tc-badge">5N/6D</div>
        </div>

        {/* ── Body ── */}
        <div className="tc-body">
          {/* Title */}
          <h2 className="tc-title">Peaks & Safaris</h2>

          {/* Night pills */}
          <div className="tc-pills">
            <span className="tc-pill">
              <span className="tc-dot" />4N Kathmandu
            </span>
            <span className="tc-sep">•</span>
            <span className="tc-pill">
              <span className="tc-dot" />2N Chitwan
            </span>
          </div>

          {/* Features grid */}
          <div className="tc-features">
            <ul className="tc-list">
              <li>Round Trip Flights</li>
              <li>4 Star Hotels</li>
              <li>3 Activities</li>
            </ul>
            <ul className="tc-list">
              <li>Intercity Car Transfers</li>
              <li>Airport Transfers</li>
              <li>Selected Meals</li>
            </ul>
          </div>

          {/* Highlights */}
          <div className="tc-highlights">
            <div className="tc-highlight-row">
           <FontAwesomeIcon icon={faArrowRight} style={{color:"green"}}></FontAwesomeIcon>
              <span>
                Visit to <span className="tc-link">Boudhanath Stupa, Swayambhunath Temple, Pashupatinath Temple + more</span>
              </span>
            </div>
            <div className="tc-highlight-row">
            <FontAwesomeIcon icon={faArrowRight} style={{color:"green"}}></FontAwesomeIcon>
              <span>
                Visit to <span className="tc-link">Nagarkot, Chitwan National Park</span>
              </span>
            </div>
          </div>

          {/* Divider */}
          <div className="tc-divider" />

          {/* Price row */}
          <div className="tc-price-row">
            <div className="tc-emi">
              <p className="tc-emi-label">Trip Starts From</p>
              <p className="tc-emi-amount">Oct 10 2026</p>
            </div>
            <div className="tc-price"onClick={()=>seTr(true)}>
              <p className="tc-price-main">
              Get a Quote
              </p>
            </div>
          </div>


        </div>
      </div>

      <div className="tc-card">
        {/* ── Image ── */}
        <div className="tc-image-wrap">
          <img
            src="/img/pokhara/pokhara3dslr.jpeg"
            alt="Pokhara, Nepal"
            className="tc-image"
          />
          <div className="tc-badge">8N/9D</div>
        </div>

        {/* ── Body ── */}
        <div className="tc-body">
          {/* Title */}
          <h2 className="tc-title">The Classic Circuit</h2>

          {/* Night pills */}
          <div className="tc-pills">
            <span className="tc-pill">
              <span className="tc-dot" />2N Kathmandu
            </span>
            <span className="tc-sep">•</span>
            <span className="tc-pill">
              <span className="tc-dot" />2N Pokhara
            </span>
            <span className="tc-sep">•</span>
            <span className="tc-pill">
              <span className="tc-dot" />2N Chitwan
            </span>
            <span className="tc-sep">•</span>
            <span className="tc-pill">
              <span className="tc-dot" />1N bandipur
            </span>
            <span className="tc-sep">•</span>
            <span className="tc-pill">
              <span className="tc-dot" />1N Nagarkot
            </span>
          </div>

          {/* Features grid */}
          <div className="tc-features">
            <ul className="tc-list">
              <li>All Entry Fee</li>
              <li>4 Star Hotels</li>
              <li>3 Activities</li>
            </ul>
            <ul className="tc-list">
              <li>Intercity Car Transfers</li>
              <li>Airport Transfers</li>
              <li>Selected Meals</li>
            </ul>
          </div>

          {/* Highlights */}
          <div className="tc-highlights">
            <div className="tc-highlight-row">
           <FontAwesomeIcon icon={faArrowRight} style={{color:"green"}}></FontAwesomeIcon>
              <span>
                Visit to <span className="tc-link">4 Place in Kathmnadu</span>
              </span>
            </div>
            <div className="tc-highlight-row">
            <FontAwesomeIcon icon={faArrowRight} style={{color:"green"}}></FontAwesomeIcon>
              <span>
                Visit to <span className="tc-link">Bindhyabasini Temple + More</span>
              </span>
            </div>
          </div>

          {/* Divider */}
          <div className="tc-divider" />

          {/* Price row */}
          <div className="tc-price-row">
            <div className="tc-emi">
              <p className="tc-emi-label">Trip Starts From</p>
              <p className="tc-emi-amount">Oct 1 2026</p>
            </div>
            <div className="tc-price"onClick={()=>seTb(true)}>
              <p className="tc-price-main">
              Get a Quote
              </p>
            </div>
          </div>


        </div>
      </div>

      
    </div>
    {opente &&( <section className="bookings">
      <div
      className="sw"
      onClick={() => seTe(false)}
    >
      Back
      
    </div>
    <Enquiryform src="/img/chitwan/chitwan4dslr.jpeg" title="Fixed Group Tour One"/></section>)}
    {opentr &&( <section className="bookings">
      <div
      className="sw"
      onClick={() => seTr(false)}
    >
      Back
      
    </div>
    <Enquiryform src="/img/chitwan/chitwan5dslr.jpeg" title="Fixed Group Tour Two"/></section>)} 
    {opentb &&( <section className="bookings">
      <div
      className="sw"
      onClick={() => seTb(false)}
    >
      Back
      
    </div>
    <Enquiryform src="/img/chitwan/chitwandslr.jpeg" title="Fixed Group Tour Three"/></section>)}
    </section>
    
  );
}